import React from 'react'
import FaqGroup from '../../models/WebContent'
import FaqCard from '../../components/FaqCard'


interface Props {
    faqs: FaqGroup[],
}

const FaqContainer: React.FC<Props> = ({ faqs = []}) => {
    return(
        <div>
            {faqs.map( (faq,id) => (
                <FaqCard
                    question={faq.question}
                    answer={faq.answer.answer}
                    key={id}
                />
            ))}
        </div>
    )
  }

  export default FaqContainer